import { CONTACT_EMAIL } from '../utils/contact';

// Who runs webspector, for the legal pages. Spain's LSSI-CE (art. 10) asks
// every website that sells or advertises to show its owner's name, tax id
// (NIF) and address. Left empty on purpose until the owner registers as
// autónomo; fill them in before charging real money or opening the site to
// the public. While a field is empty, the pages show it as pending, in red.
export const OWNER = {
  name: '',
  nif: '',
  address: ''
};

export const LEGAL_EMAIL = CONTACT_EMAIL || 'contacto@webspector.es';
export const LEGAL_UPDATED = '2 de octubre de 2026';
